import ShareAuth from '@link/share/vendors/firebase';
import { auth } from '@link/skytree/stores';

const skytreeAuth = new ShareAuth(auth);

export default skytreeAuth;
